module.exports = __webpack_public_path__ + "img/vip.b0d63413.png";